import api from './api';

/** Uploads an image file directly, returns the real URL to use as a link/attachment. */
export const uploadImage = (file) => {
  const formData = new FormData();
  formData.append('image', file);
  // The shared api instance defaults to Content-Type: application/json,
  // which would break a multipart body. Explicitly clearing it here lets
  // axios detect the FormData and have the browser set the real
  // multipart/form-data header itself, boundary included — setting that
  // header manually omits the boundary and silently breaks the upload.
  return api.post('/uploads/image', formData, { headers: { 'Content-Type': undefined } }).then(r => r.data.url);
};

/** Uploads an audio file for a course lesson (Team365 only). Returns the URL. */
export const uploadAudio = (file) => {
  const formData = new FormData();
  formData.append('audio', file);
  return api.post('/uploads/audio', formData, { headers: { 'Content-Type': undefined } }).then(r => r.data.url);
};

/** Uploads a document (PDF, Word, PowerPoint, Excel, text or a picture) for Team365 planning. Returns { url, name }. */
export const uploadFile = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post('/uploads/file', formData, { headers: { 'Content-Type': undefined } }).then(r => r.data);
};
